module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KZ-e9642861fa48436bd9153fab84eed722.png";